import React from "react";

const Leave2 = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M16 19h6" />
        <path d="M16 2v4" />
        <path d="M21 15V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.5" />
        <path d="M3 10h18" />
        <path d="M8 2v4" />
      </svg>
    </div>
  );
};

export default Leave2;
